<template>
	<div>
		<div
			v-for="(activity, index) in cart.activities"
			:key="activity.uniqueId"
			class="cart-list__item grid-x"
		>
			<div class="cell small-3 medium-2">
				<!-- Image -->
				<img class="cart-list__image" :src="activity.image" alt="cart image" />
			</div>

			<div class="cell small-9 medium-2 cart-list__mobile-header">
				<!-- Head in mobile -->
				<!-- <span class="cart-list__item-no">
					{{ $t('skipass.skipass') }} {{ index + 1 }}
				</span>
				<span class="cart-list__heading cart-list__heading--small">
					{{ skipass.name }} {{ skipass.ageGroup ? `(${skipass.ageGroup})` : '' }}
				</span>
				<span class="cart-list__validity">
					{{ $t('skipass.valid') }} {{ formatDateSpan(skipass.begindate, skipass.length) }}
				</span> -->
				<span class="cart-list__item-no">
					{{ $t('activities.activities') }} {{ index + 1 }}
				</span>
				<span class="cart-list__heading cart-list__heading--small">
					<span class="cart-list__heading-text">
						{{ activity.name }}
						{{ activity.ageGroup ? `(${activity.ageGroup})` : '' }},
						<!-- <span v-if="skischool.displayLength">
							{{ skischool.displayLength }}
						</span> -->
						<span>
							{{ dateDiff(activity.startDate, activity.endDate) }}
							{{ dayordays(dateDiff(activity.startDate, activity.endDate)) }}
						</span>
					</span>
					<!-- <span
						class="cart-list__heading-levels"
						v-if="
							activity.levels && activity.levels.length > 0 && activity.levels.length != 5
						"
					>
						<LevelLabel
							v-for="level in skischool.levels"
							:key="level.id"
							:level="level.id"
						>
							{{ level.label }}
						</LevelLabel>
					</span> -->
				</span>
			</div>

			<div class="cell small-12 medium-10">
				<!-- Buttons -->
				<div class="cart-list__buttons">
					<Button
						size="square"
						color="red"
						@click.native="
							() =>
								!activity.detlid ? showRemoveProductModal(activity) : () => {}
						"
						:disabled="activity.detlid ? true : false"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
					</Button>
				</div>

				<!-- Card -->
				<div class="cart-list__card">
					<!-- Head -->
					<div class="cart-list__head cart-list__head--with-border grid-x">
						<div class="cell small-12">
							<span class="cart-list__item-no">
								{{ $t('activities.activities') }} {{ index + 1 }}
							</span>
							<span class="cart-list__heading">
								<span class="cart-list__heading-text">
									{{ activity.name }}
									{{ activity.ageGroup ? `(${activity.ageGroup})` : '' }},
									<!-- <span v-if="skischool.displayLength">
										{{ skischool.displayLength }}
									</span> -->
									<span>
										{{ dateDiff(activity.startDate, activity.endDate) }}
										{{
											dayordays(dateDiff(activity.startDate, activity.endDate))
										}}
									</span>
								</span>
								<!-- <span
									class="cart-list__heading-levels"
									v-if="
										skischool.levels && skischool.levels.length > 0 && skischool.levels.length != 5
									"
								>
									<LevelLabel
										v-for="level in skischool.levels"
										:key="level.id"
										:level="level.id"
									>
										{{ level.label }}
									</LevelLabel>
								</span> -->
							</span>
						</div>
					</div>

					<!-- Body -->
					<div class="cart-list__body cart-list__body--with-upper-border">
						<SetProductCompanion
							:product="activity"
							:productType="'activities'"
						/>
						<div class="cart-list__table">
							<div class="cart-list__table-head grid-x">
								<div class="cell small-3 medium-2">
									<span>{{ $t('cart.price') }}</span>
								</div>
							</div>
							<div class="cart-list__table-item grid-x">
								<div class="cart-list__table-label cell small-6">
									{{ formatDateSpan(activity.startDate, activity.endDate) }}
									<br />
									{{ activity.startTime }} - {{ activity.endTime }}
									<br />
									{{ activity.groupName }}
								</div>
								<div class="cart-list__table-price cell small-6">
									{{ convertPrice(activity.price) }} SEK
								</div>
							</div>

							<ProductAddon
								:id="activity.uniqueId"
								:addon="'comment'"
								:isChecked="convertToBool(activity.comment)"
								:value="activity.comment"
								:label="$t('cart.addMessage')"
								@on-change-comment="updateAddon"
							/>
						</div>
					</div>

					<!-- Foot -->
					<div class="card-list__foot">
						<div class="cart-list__price">
							<span class="cart-list__heading">
								{{ convertPrice(activity.price) }} SEK
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal: Remove product -->
		<Modal
			v-show="showModal"
			:disableClose="true"
			:maxWidth="640"
			:heading="$t('cart.remove')"
			:text="
				this.product.name +
				' (' +
				this.product.ageGroup +
				') ' +
				product.displayLength
			"
			:closeCta="true"
			:closeCtaText="$t('cart.close')"
			@close="showModal = false"
		>
			<template v-slot:buttons>
				<Button @click.native="removeProduct(product.uniqueId)">
					{{ $t('cart.remove') }}
				</Button>
			</template>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Button from '../atoms/Button'
import ProductAddon from '../molecules/ProductAddon.vue'
import SetProductCompanion from '../molecules/SetProductCompanion'
import Modal from '../molecules/Modal'

export default {
	name: 'CartActivities',
	store,
	mixins: [mixin],
	components: {
		Button,
		ProductAddon,
		SetProductCompanion,
		Modal
	},
	computed: {
		cart() {
			return store.state.cart
		},
		user() {
			return store.state.user
		}
	},
	data() {
		return {
			showModal: false,
			product: {
				name: '',
				uniqueId: '',
				ageGroup: '',
				displayLength: ''
			}
		}
	},
	props: {},
	methods: {
		isLoggedIn() {
			return store.state.user != null
		},
		activeGuest(id) {
			return this.user.guests.find(each => each.guestlid == id)
		},
		//To do - move to action?
		showRemoveProductModal(product) {
			this.product.name = product.name
			this.product.uniqueId = product.uniqueId
			this.product.ageGroup = product.ageGroup
			this.product.displayLength = product.displayLength

			this.showModal = true
		},
		removeProduct(id) {
			store
				.dispatch('REMOVE_CART_ACTIVITIES', {
					uniqueId: id
				})
				.then(() => {
					this.product.name = ''
					this.product.uniqueId = ''
					this.product.ageGroup = ''
					this.product.displayLength = ''

					this.showModal = false

					if (store.state.cart.cartCheckoutClicked) {
						store.dispatch('VALIDATE_PRODUCTS_IN_CART')
					}
				})
		},
		updateAddon(value, id, type) {
			const actionName = 'GET_CART_ACTIVITIES_' + type.toUpperCase()
			store
				.dispatch(actionName, {
					value: value,
					uniqueId: id
				})
				.then(() => {
					this.cart.activities = store.state.cart.activities
				})
		}
	}
}
</script>

<style lang="scss" scoped></style>
